export default "__VITE_ASSET__Cy04_qXA__"